import { module as Module } from "modujs"
import { gsap, SplitText } from "gsap/all"
import { CUSTOM_EVENT, FONT } from '../config';
import { whenReady } from '../utils/fonts';
import { v4 as uuidv4 } from 'uuid';
gsap.registerPlugin(SplitText)

const CLASS = "u-anim-text"

export default class extends Module {
    constructor(m) {
        super(m)

        // Binding
        this.onResizeBind = this.onResize.bind(this)
        this.onFontsLoadedBind = this.onFontsLoaded.bind(this)

        // UI
        this.$text = this.$('text')[0] || this.el
        this.$hidden = this.$('hidden')[0] || null

        // Data
        this.lines = this.getData('lines') != null
        this.words = this.getData('words') != null
        this.chars = this.getData('chars') != null

        this.context = this.getData('context') || 'default'

        this.splitType = "lines"

        this.vWidth = window.innerWidth
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.bindEvents()
    }

    destroy() {
        super.destroy()
        this.unbindEvents()
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        whenReady(FONT.EAGER).then((fonts) => this.onFontsLoaded(fonts))
        window.addEventListener(CUSTOM_EVENT.RESIZE_END, this.onResizeBind)
    }

    unbindEvents() {
        window.removeEventListener(CUSTOM_EVENT.RESIZE_END, this.onResizeBind)
    }

    ///////////////
    // Callbacks
    ///////////////
    onResize() {
        if (this.vWidth !== window.innerWidth) {
            this.vWidth = window.innerWidth
            this.split.revert()

            requestAnimationFrame(() => {
                this.splitText()
            })
        }
    }

    onFontsLoaded(fonts) {
        if (window.preventSplitText && this.context == 'hero') {
            return
        }

        this.setUniqueID()
        this.splitText()
    }

    onInview(args) {
        if (args.way == 'leave' && this.split) {
            this.split.isSplit && this.split.revert()
        }
    }

    ///////////////
    // Methods
    ///////////////
    setUniqueID() {
        if (!this.$hidden) return

        // Create unique ID for splitted text
        const id = uuidv4()
        this.$hidden.id = id
        this.$text.setAttribute('aria-labelledby', id)
    }

    splitText() {
        this.split && this.split.revert()

        requestAnimationFrame(() => {
            // Splt text
            this.split = new SplitText(this.$text, {
                type: this.splitType,
                linesClass: `${CLASS}_line`,
                wordsClass: `${CLASS}_word`,
                charsClass: `${CLASS}_char`
            })

            // Lines
            this.split.lines.forEach(($line, lineIndex) => {
                $line.style.setProperty(
                    "--line-index",
                    lineIndex
                )
            })

            // Words
            this.split.words.forEach(($word, wordIndex) => {
                $word.style.setProperty(
                    "--word-index",
                    wordIndex
                )
            })

            // Chars
            this.split.chars.forEach(($char, charIndex) => {
                $char.style.setProperty(
                    "--char-index",
                    charIndex
                )
            })

        })
    }
}